import { Button } from 'semantic-ui-react';
import styled from 'styled-components';

export default styled(Button)`
	width: 100%;
`;
